import React, { useState, useRef, useEffect } from "react";
import "./BriefDropdownList.css";
import {
  fetchByfilter,
  fetchLanguagesByChannel,
  getUserListsByRoleIdsAndClusterId,
} from "../../services/GenericAPI";
import { fetchChannelsByClusterID } from "../../services/api";
import BriefCheckboxDropdown from "./BriefCheckboxDropdown";
import DropdownListWithObject from "../../components/DropdownList/DropdownListWithObject";
import CryptoUtils from "../../util/cryptoUtils";

const BriefDropdownList = ({
  name,
  filterName,
  title,
  isDatePicker,
  onSelect,
  value,
  className,
  multiSelection = true,
  parentSelection
}) => {
  const processValue =
    value && Array.isArray(value) ? value : value ? [value] : [];
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(processValue);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (name === "LANGUAGE") {
      if (parentSelection?.length > 0) {
        fetchLanguageByChannel(parentSelection[0]);
      } else {
        setOptions([]);
        setSelected([]);
      }
    }
  }, [parentSelection]);

  const fetchLanguageByChannel = async (channelId) => {
    setIsLoading(true);
    try {
      const response = await fetchLanguagesByChannel(channelId);
      const transformedResult = response.data.content.map((item) => ({
        id: item.languageId,
        name: item.languageName,
      }));
      setOptions(transformedResult);
    } catch (e) {
      console.error("Error in fetching Languages", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const newCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (options.length === 0 && !isLoading && name !== "LANGUAGE") {
      fetchOptions(newCluster?.[0]);
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchOptions = async (cInfo) => {
    setIsLoading(true);
    try {
      switch (filterName) {
        case "COMMISSIONING_EDITORS":
          const resultCommissioning = await getUserListsByRoleIdsAndClusterId(
            3,
            cInfo?.clusterId || 1
          );
          setOptions(resultCommissioning.data.content);
          const seletedCommissioningValue =
            resultCommissioning.data.content.filter((e) =>
              selected.includes(e.id)
            );
          setSelected(seletedCommissioningValue);
          onSelect(name, seletedCommissioningValue);
          setIsLoading(false);
          break;
        case "PRODUCERS":
          const resultProducers = await getUserListsByRoleIdsAndClusterId(5);
          setOptions(resultProducers.data.content);
          const seletedProducersValue = resultProducers.data.content.filter(
            (e) => selected.includes(e.id)
          );
          setSelected(seletedProducersValue);
          onSelect(name, seletedProducersValue);
          setIsLoading(false);
          break;
        case "Channels":
          const resultChannel = await fetchChannelsByClusterID(
            cInfo?.clusterId || 1
          );
          setOptions(
            resultChannel.data.content.map((e) => ({
              id: e.channelId||e.id,
              name: e.channelName||e.name,
            }))
          );
          setIsLoading(false);
          break;
        case "Languages":
          //don't do anything in this block
          break;
        default:
          const response = await fetchByfilter(filterName);
          const data = response.data.content[filterName];
          setOptions(data);
          setIsLoading(false);
          break;
      }
    } catch (error) {
      console.error("Error fetching options:", error);
      setIsLoading(false);
    }
  };

  const handleSelectAll = (selectAll,visibleOptions) => {
    const selectedDataString = selectAll ? visibleOptions : [];

    setSelected(selectedDataString);
    onSelect(name, selectedDataString);
  };

  const handleSelect = (value) => {
    const isSelected = selected.findIndex((e) => e?.id === value.id) !== -1;
    const newSelected = isSelected
      ? selected.filter((item) => item.id !== String(value.id))
      : [...selected, value];
    setSelected(multiSelection ? newSelected : [value.id]);
    onSelect(name, multiSelection ? newSelected : [value.id]);
  };

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const selectedValuesString = selected
    .map((id) => {
      const option = options.find(
        (option) => option.id?.toString() === id?.toString()
      );
      return option ? option.name : "";
    })
    .filter((name) => name !== "")
    .join(", ");

  const getSelectedArray = () => {
    if (selectedValuesString.length > 0) {
      return selectedValuesString.split(",");
    }
    return [];
  };

  return (
    <>
      {multiSelection && (
        <BriefCheckboxDropdown
          isOpen={isOpen}
          options={options}
          onToggle={handleToggle}
          onSelectAll={handleSelectAll}
          isDatePicker={isDatePicker}
          onSelect={handleSelect}
          selectedValues={selected}
          title={title}
          dropdownRef={dropdownRef}
          className={className}
          selectedItems={getSelectedArray()}
          search={true}
        />
      )}
      {!multiSelection && (
        <DropdownListWithObject
          key={1}
          options={options}
          selectedItem={options
            .filter((e) => e.id?.toString() === selected?.toString())
            .pop()}
          placeHolderValue={title !== "" ? title : ''}
          onSelect={handleSelect}
          selectClass={`${className}`}
        />
      )}
    </>
  );
};

export default BriefDropdownList;
